import {get} from "lodash"

import client from "@irati/utils/services/apollo"
import authentication from "@irati/auth"
import {query as getWallet} from "@irati/wallet/apollo/query/RewardWallet"

import getRewardOrder from "./queries/GetRewardOrder"
import createReward from "./queries/CreateReward"
import confirmRewardPaymentPayment from "./queries/ConfirmRewardPaymentOrder"
import sendCreditAsReward from "./queries/SendCreditAsReward"

export interface CreatePayload {
  rewardId?: string,
  productId?: string,
  custom?: string,
  teamIds?: string[],
  companyValues?: string[],
  isPrivate?: boolean,
  message?: string,
  recognition_id?: string,
  poll_id?: string,
  isCreditReward?: boolean,
  recipientUserIds: string[],
  tenantId: string,
  occasionId?: string
}

class Reward {
  getRewardOrder(rewardOrderId: string) {
    const variables = {
      tenantId: authentication.userTenant().uuid,
      orderId: rewardOrderId
    }
    return client.query({query: getRewardOrder, variables}).then((res) => res.data.rewardOrder)
  }

  create(payload: CreatePayload) {
    return client.mutate({mutation: createReward, variables: {payload}}).then((res) => res.data.createReward)
  }

  getWallet() {
    const variables = {
      currency: authentication.defaultUserCurrency(),
      tenantId: authentication.userTenant().uuid,
      userId: authentication.user().uuid
    }
    return client.query({query: getWallet, variables, fetchPolicy: "cache-first"}).then((res) => get(res, "data.rewardWallets.results[0]"))
  }

  confirmRewardPaymentOrder(rewardOrderId: string) {
    const variables = {
      tenantId: authentication.userTenant().uuid,
      orderId: rewardOrderId
    }
    return client.mutate({mutation: confirmRewardPaymentPayment, variables}).then((res) => res.data)
  }

  sendCreditAsReward(walletId: string, rewardOrderId: string) {
    const variables = {
      tenantId: authentication.userTenant().uuid,
      userId: authentication.user().uuid,
      walletId,
      rewardOrderId
    }
    return client.mutate({mutation: sendCreditAsReward, variables}).then((res) => res)
  }
}

const RewardService = new Reward()

export default RewardService
